/*eslint complexity: ["error", 21]*/
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import {
  CreateUpdateApplicationDto,
  CreateUpdateClientDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { AddressFormFields } from './AddressFormFields';
import { PolishNipPesel } from './PolishNipPesel';

interface EveryClientFormFieldsProps {
  client: CreateUpdateClientDto | CreateUpdateApplicationDto;
  propertyChange?: (obj: Partial<CreateUpdateClientDto>) => void;
  findByNip?: (text: string) => void;
  readonly?: boolean;
}

const ROWLENGHT = 30;

export const EveryClientFormFields: React.FC<
  EveryClientFormFieldsProps
> = props => {
  const [textAreaRows, setTextAreaRows] = useState(1);
  const { t, tk } = useTranslation('clientLng');

  useEffect(() => {
    setTextAreaRows(
      props.client?.name && props.client?.name.length > ROWLENGHT ? 2 : 1,
    );
  }, [props.client?.name]);

  return (
    <>
      <FormRow controlId="name" label={t(tk.common.name)}>
        <Form.Control
          as="textarea"
          rows={textAreaRows}
          value={props.client?.name || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ name: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow>

      <FormRow controlId="shortname" label={t(tk.common.shortname)}>
        <Form.Control
          type="text"
          value={props.client?.shortname || ''}
          onChange={e =>
            props.propertyChange &&
            props.propertyChange({ shortname: e.target.value })
          }
          disabled={props.readonly}
        />
      </FormRow>

      {props.client?.countryIsMain ? (
        <PolishNipPesel
          client={props.client}
          propertyChange={props.propertyChange}
          findByNip={props.findByNip}
          readonly={props.readonly}
        />
      ) : (
        <FormRow controlId="nip" label={t(tk.client.nip)}>
          <Form.Control
            type="text"
            value={props.client?.nip || ''}
            onChange={e =>
              props.propertyChange &&
              props.propertyChange({ nip: e.target.value?.trim() })
            }
            disabled={props.readonly}
          />
        </FormRow>
      )}

      <AddressFormFields
        client={props.client}
        propertyChange={props.propertyChange}
        readonly={props.readonly}
      />
    </>
  );
};
